import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { captureException } from "@sentry/react";

export const cancelNextProduct = createAsyncThunk<void, void, ThunkConfig<ApiError>>(
  "subscription/cancelNextProduct",
  async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/subscription/cancel_next_product");
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
